var map = {
	"./Canteen.svg": 44951,
	"./Info.svg": 13180,
	"./Mail-details-page.svg": 41365,
	"./Map-icon-mobile-hover.svg": 50075,
	"./Map-icon-mobile.svg": 18727,
	"./Phone-details-page.svg": 40137,
	"./alert.svg": 15748,
	"./area-ft2.svg": 14526,
	"./area-m2.svg": 47406,
	"./area.svg": 77414,
	"./arrow-bottom-mobile.svg": 74977,
	"./arrow_upward.svg": 12095,
	"./cafe-icon.svg": 97682,
	"./category-banner-provider.svg": 24182,
	"./check_circle.svg": 25881,
	"./close.svg": 17551,
	"./common-icons.svg": 40404,
	"./cookie-badge.svg": 26011,
	"./delete-hover.svg": 51192,
	"./delete.svg": 56391,
	"./desks.svg": 80066,
	"./disposal-icon.svg": 7370,
	"./disposal.svg": 69822,
	"./edit-hover.svg": 56565,
	"./edit.svg": 81980,
	"./facebook-logo.svg": 31763,
	"./facebook.svg": 43950,
	"./facts_and_facilities/ExemptedEnergyRating.svg": 10461,
	"./facts_and_facilities/Map.svg": 49476,
	"./facts_and_facilities/access24Hour.svg": 29649,
	"./facts_and_facilities/airConditioning.svg": 69400,
	"./facts_and_facilities/airport.svg": 14120,
	"./facts_and_facilities/alarmSystem.svg": 93333,
	"./facts_and_facilities/atm.svg": 24428,
	"./facts_and_facilities/balcony.svg": 50546,
	"./facts_and_facilities/bank.svg": 11867,
	"./facts_and_facilities/bar.svg": 9029,
	"./facts_and_facilities/bicycle_parking.svg": 2727,
	"./facts_and_facilities/bikeRacks.svg": 94615,
	"./facts_and_facilities/boat.svg": 28276,
	"./facts_and_facilities/build_route.svg": 73403,
	"./facts_and_facilities/bus.svg": 46578,
	"./facts_and_facilities/cafe.svg": 25218,
	"./facts_and_facilities/canteen.svg": 58132,
	"./facts_and_facilities/car_repair.svg": 63070,
	"./facts_and_facilities/car_wash.svg": 83631,
	"./facts_and_facilities/catering.svg": 8333,
	"./facts_and_facilities/charging_station.svg": 87973,
	"./facts_and_facilities/cinema.svg": 7993,
	"./facts_and_facilities/cleaning.svg": 35702,
	"./facts_and_facilities/clinic.svg": 19481,
	"./facts_and_facilities/closedCircuitTelevision.svg": 61552,
	"./facts_and_facilities/coffee_shop.svg": 83369,
	"./facts_and_facilities/conferenceRooms.svg": 38855,
	"./facts_and_facilities/cooling.svg": 52156,
	"./facts_and_facilities/copying_facilities.svg": 55943,
	"./facts_and_facilities/coworking.svg": 22328,
	"./facts_and_facilities/coworkingSpace.svg": 9078,
	"./facts_and_facilities/currency_exchange.svg": 1396,
	"./facts_and_facilities/default.svg": 14443,
	"./facts_and_facilities/dentist.svg": 61141,
	"./facts_and_facilities/disabled.svg": 44905,
	"./facts_and_facilities/electricCarCharge.svg": 90081,
	"./facts_and_facilities/elevator.svg": 92105,
	"./facts_and_facilities/enclosedProperty.svg": 34976,
	"./facts_and_facilities/fast_food.svg": 52784,
	"./facts_and_facilities/fiberInternet.svg": 8842,
	"./facts_and_facilities/fitness_centre.svg": 22566,
	"./facts_and_facilities/furnished.svg": 61368,
	"./facts_and_facilities/gym.svg": 52283,
	"./facts_and_facilities/hotDesk.svg": 20670,
	"./facts_and_facilities/hotel.svg": 73704,
	"./facts_and_facilities/itSupport.svg": 55996,
	"./facts_and_facilities/kitchenette.svg": 43486,
	"./facts_and_facilities/light_rail.svg": 1280,
	"./facts_and_facilities/local_train.svg": 71667,
	"./facts_and_facilities/lounge.svg": 73111,
	"./facts_and_facilities/mall.svg": 13680,
	"./facts_and_facilities/meetingRooms.svg": 12553,
	"./facts_and_facilities/metro.svg": 41542,
	"./facts_and_facilities/outdoorArea.svg": 22163,
	"./facts_and_facilities/ownSignage.svg": 5870,
	"./facts_and_facilities/parking.svg": 14535,
	"./facts_and_facilities/petFriendly.svg": 88842,
	"./facts_and_facilities/pharmacy.svg": 34997,
	"./facts_and_facilities/phoneAnswering.svg": 93854,
	"./facts_and_facilities/post_office.svg": 33210,
	"./facts_and_facilities/postalFacilities.svg": 13333,
	"./facts_and_facilities/privateOffices.svg": 85383,
	"./facts_and_facilities/pub.svg": 67007,
	"./facts_and_facilities/reception.svg": 52981,
	"./facts_and_facilities/restaurant.svg": 63481,
	"./facts_and_facilities/s-train.svg": 39839,
	"./facts_and_facilities/secretarial.svg": 26928,
	"./facts_and_facilities/shower.svg": 39921,
	"./facts_and_facilities/spatialPlanning.svg": 35998,
	"./facts_and_facilities/storage.svg": 72648,
	"./facts_and_facilities/supermarket.svg": 23604,
	"./facts_and_facilities/taxi.svg": 67874,
	"./facts_and_facilities/telephoneSystem.svg": 90645,
	"./facts_and_facilities/train.svg": 79953,
	"./facts_and_facilities/tram.svg": 49989,
	"./facts_and_facilities/trolleybus.svg": 67301,
	"./facts_and_facilities/unfurnished.svg": 98409,
	"./facts_and_facilities/videoConference.svg": 28575,
	"./facts_and_facilities/virtualOffices.svg": 80038,
	"./facts_and_facilities/wC.svg": 43575,
	"./facts_and_facilities/wifi.svg": 74726,
	"./facts_and_facilities/yoga.svg": 75703,
	"./favorite_empty_page.svg": 78148,
	"./file-download.svg": 15,
	"./google-translate.svg": 86902,
	"./half-star.svg": 20990,
	"./heart-active.svg": 12516,
	"./heart.svg": 27237,
	"./heart_empty.svg": 913,
	"./heart_full.svg": 74578,
	"./home.svg": 52227,
	"./info.svg": 32312,
	"./instagram.svg": 54885,
	"./keyboard_arrow_right-rounded.svg": 91992,
	"./linkedin.svg": 97562,
	"./list-view-map-icon.svg": 39595,
	"./list-view-map-noborder.svg": 89857,
	"./list-view-map.svg": 24005,
	"./mail.svg": 70285,
	"./mouse-pointer.svg": 91334,
	"./nearby-location-banner.svg": 16367,
	"./no-rsults.svg": 98992,
	"./outlined-star.svg": 57232,
	"./parking.svg": 28053,
	"./parking_places.svg": 88985,
	"./person.svg": 24148,
	"./phone_icon.svg": 86937,
	"./price.svg": 34560,
	"./search-agent.svg": 7095,
	"./search.svg": 62153,
	"./share.svg": 56398,
	"./star.svg": 41801,
	"./transport-boat.svg": 22132,
	"./transport-bus.svg": 6228,
	"./transport-metro.svg": 56914,
	"./transport-s-train.svg": 84741,
	"./transport-train.svg": 80074,
	"./transport-tram.svg": 1710,
	"./trustpilot-3-half.svg": 12524,
	"./trustpilot-3.svg": 75382,
	"./trustpilot-4-half.svg": 10485,
	"./trustpilot-4.svg": 83305,
	"./trustpilot-5.svg": 31258,
	"./twitter.svg": 56502,
	"./unavaillable-location-icon.svg": 98724,
	"./verified.svg": 62222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11751;